export default __webpack_public_path__ + "static/char-s-39-zh-Hans-a5fb4e9ddc950d0660adef564e388ab8.webp";